import React, {Component} from 'react';
import Team from './Team';

class Round6 extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }
    

    render() {
        var teams = this.props.teams;

        function getTransform(idx) {
            var angle = 360/2 * (.5 + idx);
            // var width = window.innerWidth/2;
            var width = 900/2;
            var unit = width/12;
            var size = 2.25 * unit;
            return `translate(-50%,-50%) rotate(${angle}deg) translate(0,-${size}px) rotate(-${angle}deg)`;
        }
        
        return (
            <div className="round6 circle-wrapper">
                {teams.map((team,idx) => (
                    <div key={idx} className="team4" style={{transform:getTransform(idx)}}>
                        <Team 
                            onClick={this.props.onClick}
                            onHover={this.props.onHover}
                            round={6}
                            team={team} ></Team>
                    </div>
                ))}
            </div>
        );
    }
}

export default Round6;